import { Radio, RadioGroup, Button, Icon } from '@components';
import doczSet from '@root/doczrc.js';
import * as React from 'react';
export default {
  Radio,
  RadioGroup,
  Button,
  Icon,
  doczSet,
  React
};